import { appOrigin } from "@/lib/absolute-url";
import { buildArtistHubPath } from "@garimpa/lib/buildArtistHubPath";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function buildArtistHubJsonLd(input: {
  locale: ViewerLocale;
  title: string;
  description: string;
  directories: Array<{ label: string; path: string }>;
}) {
  const url = `${appOrigin()}${buildArtistHubPath(input.locale)}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "CollectionPage",
        "@id": `${url}#page`,
        url,
        name: input.title,
        description: input.description,
        inLanguage: input.locale,
        isPartOf: { "@id": `${appOrigin()}/#website` },
        mainEntity: {
          "@type": "ItemList",
          numberOfItems: input.directories.length,
          itemListElement: input.directories.map((directory, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: directory.label,
            url: `${appOrigin()}${directory.path}`,
          })),
        },
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: input.title,
            item: url,
          },
        ],
      },
    ],
  };
}
